// extracted by mini-css-extract-plugin
export var quantityInput = "_gx-0";